import script from "./CustomerSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerSelect.vue?vue&type=script&setup=true&lang=js"

import "./CustomerSelect.vue?vue&type=style&index=0&id=4926018f&lang=less"
import "./CustomerSelect.vue?vue&type=style&index=1&id=4926018f&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4926018f"]])

export default __exports__